import _ from 'lodash';
import { } from 'underscore';
import { Vue } from 'ui.vue';
import { Loc } from 'main.core';
// import { CurrencyCore } from "currency.currency-core";
import { userStore } from 'germes.multibasket';
import { ProductLabel } from 'germes.multibasket.src.entity.productlabel';

userStore.registerModule('catalog', {
    namespaced: true,
    state: {
        SECTIONS: {},
        ITEMS: {},
        initHandler: false,
        basketUrl: '/catalog/?action=ADD2BASKET&id=#ID#',
        productSettingsModule: {},
        productVisibleCols: [],
        productLabels: {},
    },
    mutations: {
        addItem: function (state, item) {
            if (state.ITEMS[item.ID] == undefined) {
                Vue.set(state.ITEMS, item.ID, item);
                if (typeof item == 'object' && this.hasModule('basket')) {
                    Vue.set(item, "QUANTITY", this.getters['basket/getItemQuantity'](item.ID));
                }
                // // выбираем какие свойства нужно сделать реактивными
                // Vue.set(item, "PRICE", item.PRICE);
                // Vue.set(item, "DISCOUNT_PRICE", item.DISCOUNT_PRICE);
                // Vue.set(item, "ANALOG", item.ANALOG); // список аналогов
                // Vue.set(item, "PROPS", item.PROPS);
                let event = { catalogProduct: item, result: true };
                BX.onCustomEvent("OnCatalogItemInit", event); // INFO any run of addItem shuld run event!
                BX.onCustomEvent("OnCatalogItemUpdate", event); // INFO any run of addItem shuld run event!
            } else {
                this.commit('catalog/updateItem', item);
            }
        },
        updateItem: function (state, item) {
            if (state.ITEMS[item.ID] != undefined) {
                Vue.set(state.ITEMS, item.ID, Object.assign({}, state.ITEMS[item.ID], item, { ID: item.ID }));
                if (typeof item == 'object' && this.hasModule('basket')) {
                    Vue.set(item, "QUANTITY", this.getters['basket/getItemQuantity'](item.ID));
                }
                let event = { catalogProduct: item, result: true };
                BX.onCustomEvent("OnCatalogItemUpdate", event); // INFO any run of addItem shuld run event!
            } else {
                this.commit('catalog/addItem', item);
            }
        },
        updateItems: function (state, items) {
            for (const itemid in items) {
                if (Object.hasOwnProperty.call(items, itemid)) {
                    this.commit('catalog/updateItem', items[itemid]);
                }
            }
        },
        updateItemsPrice: function (state, newPriceList) {
            if (newPriceList != undefined) {
                for (const itemid in newPriceList) {
                    if (Object.hasOwnProperty.call(newPriceList, itemid)) {
                        let cartItem = this.getters['catalog/findItem'](itemid);
                        Vue.set(cartItem, 'BASE_PRICE', newPriceList[itemid].BASE_PRICE);
                        Vue.set(cartItem, 'PRICE', newPriceList[itemid].PRICE);
                    }
                }
            } else {
                this.dispatch('showNotificate', { message: 'Цены в каталоге не обновлены!' });
            }
        },
        setItemPrice: function (state, newItem) {
            let oldItem = this.getters['catalog/findItem'](newItem.XML_ID);
            if (oldItem?.ID != undefined) oldItem.PRICE = parseFloat(newItem.PRICE.replace(/[^\d|\.|\,]+/ig, ''));
        },
        setProductLabel: function (state, { product_xml_id, contragent_id, labelData }) {
            let id = contragent_id + '/' + product_xml_id;
            if (typeof state.productLabels?.[id] === 'undefined') {
                state.productLabels[id] = {};
            }
            state.productLabels[id][labelData.CODE] = new ProductLabel(labelData);
        },
        removeItem: function (state, removeItem) {
            let oldItem = this.getters['catalog/findItem'](removeItem.ID);
            if (oldItem?.ID != undefined) Vue.set(state.ITEMS, oldItem.ID, null);
        },
        addProductSettingsModule: function (state, module) {
            try {
                // INFO только уникальные значения комопнентов!!
                if (module.sort == undefined) module.sort = 100;
                if (module.name !== undefined) state.productSettingsModule[module.name] = module;
                else throw "No module name";
            } catch (error) {
                console.error(error);
            }
        },
        setCatalogColsSettings: function (state, settings) {
            try {
                if (!settings) {
                    settings = [
                        {
                            sort: 100,
                            type: 'string',
                            itemObjectPath: 'PROPERTIES.CML2_ARTICLE',
                            colValuePath: 'VALUE'
                        },
                        // 'PROPERTIES.PICTURES.VALUE': {
                        //     sort: 100,
                        //     type: 'image',
                        //     itemObjectPath: 'PROPERTIES.PICTURES',
                        //     colValuePath: 'VALUE'
                        // },
                        {
                            sort: 200,
                            type: 'string',
                            itemObjectPath: 'PREVIEW_TEXT',
                            colValuePath: ''
                        },
                        {
                            sort: 300,
                            type: 'string',
                            itemObjectPath: 'PROPERTIES.PACKAGE_FORMAT',
                            colValuePath: 'VALUE'
                        },
                        {
                            sort: 2100,
                            type: 'string',
                            itemObjectPath: 'PRICE',
                            colValuePath: ''
                        },
                        {
                            sort: 2200,
                            type: 'string',
                            itemObjectPath: 'QUANTITY',
                            colValuePath: ''
                        },
                        {
                            sort: 2300,
                            type: 'string',
                            itemObjectPath: 'PRICE_SUM',
                            colValuePath: ''
                        }
                    ];
                }
                for (const i in settings) {
                    if (Object.hasOwnProperty.call(settings, i)) {
                        state.productVisibleCols[settings[i].itemObjectPath] = settings[i];
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
    },
    actions: {
        initEventHandler: function (state) {
            if (!state.state.initHandler) {
                if (typeof userOptions == 'object' && userOptions?.multibasket?.CatalogSettings !== undefined) {
                    this.commit('catalog/setCatalogColsSettings', userOptions.multibasket.CatalogSettings);
                } else {
                    this.commit('catalog/setCatalogColsSettings', null);
                }
                BX.addCustomEvent('Grid::updated', BX.proxy(function (event) {
                    BX.onCustomEvent("OnAfterCatalogStoreInit");
                    // this.dispatch('catalog/initComponents');
                }, this));
                BX.addCustomEvent('onAjaxSuccessFinish', BX.proxy(function (event) {
                    BX.onCustomEvent("OnAfterCatalogStoreInit");
                    // this.dispatch('catalog/initComponents');
                }, this));
                BX.addCustomEvent("OnAfterBasketAddProduct", BX.proxy(function (event) {
                    try {
                        let product = event.data;
                        this.dispatch('catalog/updateNode', {
                            product: product,
                            type: 'add'
                        });
                    } catch (error) {
                        console.debug(error);
                    }
                }, this));
                BX.addCustomEvent("OnAfterBasketDeleteProduct", BX.proxy(function (event) {
                    try {
                        let product = event.data;
                        this.dispatch('catalog/updateNode', {
                            product: product,
                            type: 'delete'
                        });
                    } catch (error) {
                        console.debug(error);
                    }
                }, this));
                BX.addCustomEvent("OnAfterBasketUpdateProduct", BX.proxy(function (event) {
                    try {
                        let product = event.data;
                        this.dispatch('catalog/updateNode', {
                            product: product,
                            type: 'update'
                        });
                    } catch (error) {
                        console.debug(error);
                    }
                }, this));
                BX.addCustomEvent("OnAfterContragentChange", BX.proxy(function (event) {
                    try {
                        BX.onCustomEvent('OnBeforeCatalogUpdatePrice');
                        let data = {
                            action: 'getPrice',
                            items_id: this.getters['catalog/getItemsXML_ID']
                        }
                        if (data.items_id && Object.keys(data.items_id)?.length) {
                            this.dispatch('submit', data).then(response => {
                                this.commit('catalog/updateItemsPrice', response.data);
                                this.dispatch('showNotificate', { message: this.getters['catalog/localize']('UPDATE_PRICE_Y'), category: 'OnCatalogUpdatePrice' });
                                BX.onCustomEvent('OnAfterCatalogUpdatePrice');
                            }, error => {
                                this.dispatch('showNotificate', { message: this.getters['catalog/localize']('UPDATE_PRICE_N'), category: 'OnCatalogUpdatePrice' });
                                console.debug(error);
                            });
                        }
                    } catch (error) {
                        console.debug(error);
                    }
                }, this));
                BX.addCustomEvent("OnBeforeBasketSet", BX.proxy(function (event) {
                    let catalogItems = this.getters['catalog/getItems'];
                    for (const i in catalogItems) {
                        if (Object.hasOwnProperty.call(catalogItems, i)) {
                            catalogItems[i].QUANTITY = null;
                        }
                    }
                }, this));
                // INFO synchronize items in cart and catalog items
                BX.addCustomEvent("OnAfterBasketSet", BX.proxy(function (event) {
                    let basketItems = this.getters['basket/getItems'];
                    for (const i in basketItems) {
                        if (Object.hasOwnProperty.call(basketItems, i)) {
                            let catalogProduct = Object.assign({}, basketItems[i]);
                            catalogProduct.ID = catalogProduct.PRODUCT_ID;
                            this.commit('catalog/updateItem', catalogProduct);
                        }
                    }
                }, this));
                BX.ready(BX.proxy(function () {
                    BX.onCustomEvent("OnAfterCatalogStoreInit");
                }, this));
                state.state.initHandler = true;
            }
        },
        // TODO вынуженная временная мера по обновлению DOM вне компонента Vue
        updateNode: function (state, data) {
            let product = data.product
            let catalogProduct = null;
            if (product.PRODUCT_ID != undefined) {
                catalogProduct = this.getters['catalog/findItem'](product.PRODUCT_ID);
                if (catalogProduct && catalogProduct.VISUAL) {
                    let productRow = BX(catalogProduct.VISUAL.SKU_ROW);
                    if (productRow != undefined && data.type == "delete") {
                        BX.removeClass(productRow, 'in_basket');
                    } else if (productRow) {
                        BX.addClass(productRow, 'in_basket');
                    }
                }
            }
        },
        send2Basket: function (state, product) {
            try {
                // INFO единственное место передачи количества из каталога в корзину Vuex
                if ("CHECK AUTH" && !BX.message('USER_ID')) {
                    this.dispatch('showNotificate', {
                        message: BX.message("NOTIFICATE_NEED_AUTH")
                            .replace(/#CML2_ARTICLE#/gi, product.CML2_ARTICLE)
                            .replace(/#NAME#/gi, product.NAME)
                            .replace(/#ID#/gi, product.ID)
                            .replace(/#QUANTITY#/gi, parseFloat(product.QUANTITY)),
                        id: product.ID
                    });
                    product.QUANTITY = null;
                } else if (typeof product == 'object' && this.hasModule('basket')) {
                    var basketProduct = this.getters['basket/findItem'](product.PRODUCT_ID || product.ID);
                    if (!basketProduct?.ID) {
                        return this.commit("basket/addProduct", product);
                    } else {
                        basketProduct = Object.assign(basketProduct, product, { ID: basketProduct.ID });
                        if (product.QUANTITY <= 0) {
                            return this.commit("basket/deleteProduct", basketProduct);
                        } else {
                            return this.commit("basket/updateProduct", basketProduct);
                        }
                    }
                } else {
                    console.debug(product);
                }
            } catch (error) {
                alert('send2Basket unexpected error!');
                console.debug(product);
            }
            return false;
        },
        changeQuantity: function (store, data) {
            try {
                Vue.set(store.state.ITEMS[data.item.ID], 'QUANTITY', data.quantity);
                if (store.state.ITEMS[data.item.ID] != undefined && data.item.SEND2BASKET == true) {
                    return this.dispatch('catalog/send2Basket', store.state.ITEMS[data.item.ID]);
                } else if (store.state.ITEMS[data.item.ID] != undefined && data.item.SEND2BASKET == false) {
                    return this.dispatch('catalog/checkParams', store.state.ITEMS[data.item.ID]);
                }
            } catch (error) {
                console.error(error);
            }
            return false;
        },
        checkParams: function (store, catalogProduct) {
            catalogProduct.IMITATE = "Y";
            if (catalogProduct.PRODUCT_ID === undefined) catalogProduct.PRODUCT_ID = catalogProduct.ID;
            let submitData = this.getters['basket/getPostData'](Object.assign({}, catalogProduct), 'check');
            this.dispatch('submit', submitData)
                .then(response => {
                    catalogProduct.IMITATE = null;
                    store.commit('updateItem', Object.assign({}, catalogProduct, response.data))
                }, error => {
                    catalogProduct.IMITATE = null;
                    console.debug(error);
                })
        },
    },
    getters: {
        localize: (state) => (CODE) => {
            return BX.Vue.getFilteredPhrases('')[CODE];
        },
        findItem: (state, getters, rootState, rootGetters) => (find_product_str) => {
            var product = state.ITEMS[find_product_str] || {};
            if (!product?.ID) {
                for (const i in state.ITEMS) {
                    if (Object.hasOwnProperty.call(state.ITEMS, i)
                        && (state.ITEMS[i].ID == find_product_str
                            || state.ITEMS[i].PRODUCT_ID == find_product_str
                            || state.ITEMS[i].XML_ID == find_product_str
                        )
                    ) {
                        product = state.ITEMS[i];
                        Vue.set(product, "QUANTITY", product.QUANTITY);
                        Vue.set(product, "PRICE", product.PRICE);
                        Vue.set(product, "ANALOG", product.ANALOG);
                        Vue.set(product, "PROPS", product.PROPS);
                        Vue.set(product, "WHAIT_RC", product.WHAIT_RC);
                        Vue.set(product, "STORE", product.STORE);
                        Vue.set(product, "CAN_BUY_IN_PERCENT", product.CAN_BUY_IN_PERCENT);
                        break;
                    }
                }
            }
            return product;
        },
        getLabelList: (state, getters, rootState, rootGetters) => {
            return state.productLabels;
        },
        getProductLabels: (state, getters, rootState, rootGetters) => (catalogProduct) => {
            let labels = {},
                contragent_id = rootGetters['basket/getContragentId'],
                product_xml_id = (catalogProduct?.PRODUCT_XML_ID ?? catalogProduct?.XML_ID)?.replace(/(.)*#/i, ''),
                id = contragent_id + '/' + product_xml_id;
            if (typeof getters.getLabelList?.[id] !== 'undefined') {
                labels = getters.getLabelList[id]
            }
            return labels;
        },
        getSections(state) {
            return state.SECTIONS;
        },
        getItems(state) {
            return state.ITEMS;
        },
        getItemsXML_ID: (state, getters, rootState, rootGetters) => {
            let result = {},
                itemList = getters.getItems;
            if (itemList !== null && typeof itemList == 'object' && Object.keys(itemList).length)
                for (const i in itemList)
                    if (Object.hasOwnProperty.call(itemList, i))
                        result[i] = itemList[i].XML_ID;
            return result;
        },
        getPostData: (state) => (postedData) => {
            if (typeof postedData == 'object' && postedData.PRODUCT_ID !== undefined) {
                postedData.url = state.basketUrl?.replace('#ID#', postedData.PRODUCT_ID?.toString());
                postedData.ajax_basket = 'Y';
                postedData.action = 'ADD2BASKET';
                if (typeof postedData.QUANTITY != 'undefined') {
                    postedData.quantity = postedData.QUANTITY;
                }
                return postedData;
            } else {
                throw "Error! Empty postedData";
            }
        },
        getCatalogProductCols: (state, getters, rootState, rootGetters) => (catalogProduct) => {
            let resultColsObjList = {},
                productVisibleCols = Object.values(state.productVisibleCols).sort((a, b) => {
                    if (a.sort == undefined) a.sort = 100;
                    if (b.sort == undefined) b.sort = 100;
                    if (a.sort > b.sort) return 1;
                    if (a.sort < b.sort) return -1;
                    return 0;
                });
            if (productVisibleCols !== undefined) {
                for (const colPropCode in productVisibleCols) {
                    if (Object.hasOwnProperty.call(productVisibleCols, colPropCode)) {
                        let colProp = productVisibleCols[colPropCode],
                            propVal = colProp.colValuePath,
                            propPath = colProp.itemObjectPath;
                        propPath = propPath.split('.');
                        if (Array.isArray(propPath) && propPath.length) {
                            let prop = catalogProduct;
                            let propPathName;
                            do {
                                propPathName = propPath.splice(0, 1);
                                if (prop[propPathName] === undefined) {
                                    break;
                                }
                                prop = prop[propPathName];
                            } while (propPath.length && typeof prop == 'object');
                            if (colProp && prop != undefined) {
                                if (typeof prop != 'object') prop = { 'VALUE': prop };
                                colProp = Object.assign({}, colProp, prop);
                                resultColsObjList[colPropCode] = Object.assign(colProp, prop, {
                                    CODE: (colProp.CODE || colProp.itemObjectPath),
                                    TITLE: (colProp.DESCRIPTION || colProp.NAME),
                                    NAME: (colProp.NAME || colProp.itemObjectPath),
                                    SORT: (colProp.sort || 100),
                                    MULTIPLE: (colProp.MULTIPLE || "N"),
                                    TYPE: (colProp.type || "string"),
                                    VALUE: (prop[propVal] || prop['VALUE']),
                                });
                            }
                        }
                    }
                }
            }
            return resultColsObjList;
        },
        getProductSettingsModule(state) {
            return Object.values(state.productSettingsModule).sort((a, b) => {
                if (a.sort == undefined) a.sort = 100;
                if (b.sort == undefined) b.sort = 100;
                if (a.sort > b.sort) return 1;
                if (a.sort < b.sort) return -1;
                return 0;
            });
        },
    }
});
userStore.dispatch('catalog/initEventHandler');
